


export enum AplosFileCategory {

    NCAInput = "nca_input",
    Execution = "execution"
}